import { Button } from "@/components/ui/button";
import { fetchColumnsViewFiels, fetchColumnsViews } from "@/store/actions/ColumnsViewsActine";
import { newFetchCustomColumnsViews } from "@/store/actions/CustomColumnsViewsAction";
import { fetchAllocationColumn, fetchPortfolioGroupAllocationColumn, fetchPortfolioGroupInvestedAssetColumn } from "@/store/actions/portfolioscolumnAction";
import { Settings } from "lucide-react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import ListViewModal from "./components/ListViewModal";

const NewMultipleViewSetting = (props) => {
     const { sectionType, isGroup, isAsset, isAssetMonitor, setIsRefetch } = props;
     const dispatch = useDispatch();
     const portfolioId = localStorage.getItem('portfolioId');
     const [settingModalOpen, setSettingModalOpen] = useState(false);
     const [fields, setFields] = useState([]);
     const [viewFields, setViewFields] = useState([]);
     const [activeFields, setActiveFields] = useState([]);
     const [searchValue, setSearchValue] = useState('');
     const [isLoading, setIsLoading] = useState(false);
     const [isLoadingFields, setIsLoadingFields] = useState(false);
     const [viewId, setViewId] = useState(null);
     const [getObjId, setGetObjId] = useState([]);
     const [name, setName] = useState('');

     useEffect(() => {
          isAssetMonitor === 'allocationMonitor' && dispatch(fetchAllocationColumn('allocationMonitor'));
          isGroup && dispatch(fetchPortfolioGroupInvestedAssetColumn('portfolioGroupInvestedAsset'))
          isAssetMonitor === 'portfolioGroupAllocationMonitor' && dispatch(fetchPortfolioGroupAllocationColumn('portfolioGroupAllocationMonitor'))
     }, [])

     useEffect(() => {
          if (settingModalOpen) {
               setViewId(null);
               setActiveFields([]);
               setGetObjId([]);
               setViewFields([]);
               setFields([]);
               setName('');
               setSearchValue('');
          }
     }, [settingModalOpen])

     useEffect(() => {
          if (fields) {
               const groupViseFields = Object.keys(fields)?.map((item) => {
                    if (fields[item] && Array.isArray(fields[item]) && fields[item]?.length > 0) {
                         const toleranceFieldsWithFields = fields[item]?.filter(fieldObj => fieldObj?.fields && Array.isArray(fieldObj?.fields));
                         if (toleranceFieldsWithFields?.length > 0) {
                              const extractedFields = toleranceFieldsWithFields?.map(fieldObj => fieldObj?.fields)?.flat();
                              const fieldsWithType = extractedFields?.map(field => ({
                                   ...field,
                                   fieldType: item
                              }));
                              return {
                                   group: item,
                                   fields: fieldsWithType
                              }
                         } else {
                              const fieldsWithType = fields[item]?.map(field => ({
                                   ...field,
                                   fieldType: item
                              }));
                              return {
                                   group: item,
                                   fields: fieldsWithType
                              }
                         }
                    } else {
                         const fieldsWithType = fields[item]?.map(field => ({
                              ...field,
                              fieldType: item
                         }));
                         return {
                              group: item,
                              fields: fieldsWithType
                         }
                    }
               });
               setViewFields(groupViseFields);
          }
     }, [fields])

     useEffect(() => {
          if (settingModalOpen) {
               dispatch(newFetchCustomColumnsViews(sectionType, searchValue, getObjId, portfolioId, setIsLoading)).then((res) => {
                    setFields(res);
               })
          }
     }, [dispatch, settingModalOpen, searchValue])

     useEffect(() => {
          if (viewId) {
               dispatch(fetchColumnsViewFiels(viewId, setIsLoadingFields)).then((res) => {
                    const columns = res?.data?.columns || [];
                    const toleranceFields = res?.data?.toleranceFields || [];
                    const processedColumns = columns.map(column => ({
                         ...column,
                         fieldType: column?.type === "default" ? "defaultFields" : "customFields"
                    }));

                    const processedToleranceFields = toleranceFields?.map(toleranceItem => {
                         const toleranceParameterFields = toleranceItem?.toleranceParameterFields;
                         return {
                              ...toleranceParameterFields,
                              fieldType: 'toleranceFields'
                         };
                    });

                    const combinedFields = [...processedColumns, ...processedToleranceFields];
                    setActiveFields(combinedFields);
                    setGetObjId(combinedFields.map(field => field?._id));
               })
          }
     }, [viewId])

     useEffect(() => {
          dispatch(newFetchCustomColumnsViews(sectionType, searchValue, getObjId, portfolioId, setIsLoading)).then((res) => {
               setFields(res);
          })
     }, [getObjId])

     return (
          <>
               <Button variant="outline" size="sm" className="h-8 hover:bg-[#F5F5F5]" onClick={() => {
                    setSettingModalOpen(true);
               }}>
                    <span><Settings strokeWidth={"2.2"} className="w-4 h-4" /></span>  Setting
               </Button>
               {settingModalOpen && <ListViewModal show={settingModalOpen} onHide={() => setSettingModalOpen(false)} viewFields={viewFields} setActiveFields={setActiveFields} activeFields={activeFields} setViewFields={setViewFields} setSearchValue={setSearchValue} searchValue={searchValue} isLoading={isLoading} viewId={viewId} setViewId={setViewId} isLoadingFields={isLoadingFields} name={name} setName={setName} sectionType={sectionType} setIsRefetch={setIsRefetch} />}
          </>
     )
}
export default NewMultipleViewSetting;
